<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="about-box1">
      <div class="w1200">
        <h1 class="about-title">{{aboutitle}}</h1>
        <div class="about-box1-cont" v-html="aboutcontent">
        </div>
      </div>
    </div>
    <div class="about-box2">
      <div class="w1200">
        <h1 class="about-title">{{ $t('culture')}}</h1>
        <ul class="qywhlist">
          <li>
            <i></i>
            <h1>{{ $t('abouta')}}</h1>
            <span>{{ $t('aboutb')}}</span>
          </li>
          <li>
            <i></i>
            <h1>{{ $t('aboutc')}}</h1>
            <span>{{ $t('aboutd')}}</span>
          </li>
          <li>
            <i></i>
            <h1>{{ $t('aboute')}}</h1>
            <span>{{ $t('aboutf')}}</span>
          </li>
          <li>
            <i></i>
            <h1>{{ $t('aboutg')}}</h1>
            <span>{{ $t('abouth')}}</span>
          </li>
          <li>
            <i></i>
            <h1>{{ $t('abouti')}}</h1>
            <span>{{ $t('aboutj')}}</span>
          </li>
          <li>
            <i></i>
            <h1>{{ $t('aboutk')}}</h1>
            <span v-html="$t('aboutl')"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="about-box3">
      <div class="w1200">
        <h1 class="about-title">{{ $t('development')}}</h1>
        <div class="brand">
          <ul class="fzlclist amn3" :style="{left:-300*(index)+'px',width: 310 * alllength+'px'}">
            <li v-for="(item,index) in development" :key="index">
              <h1>{{item.time}}</h1>
              <i></i>
              <span>
                {{item.title}}
              </span>
            </li>
          </ul>
        </div>
        <div class="btnbox">
          <div class="prev" @click="developmentleft"></div>
          <div class="next" @click="developmentright"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'About',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      index: 0,
      alllength: 0,
      type: '',
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      aboutitle: '',
      aboutcontent: '',
      development: []
    }
  },
  mounted () {
    const that = this
    this.$nextTick(() => {
      if (that.type === 1) {
        window.scrollTo(0, 600)
      } else if (that.type === 2) {
        window.scrollTo(0, document.querySelector('.about-box2').offsetTop)
      } else if (that.type === 3) {
        window.scrollTo(0, document.querySelector('.about-box3').offsetTop)
      }
    })
  },
  methods: {
    developmentleft: function () {
      const that = this
      if (that.alllength > 4) {
        if (that.index - 1 < 0) {
          that.index = 0
        } else {
          that.index--
        }
      }
    },
    developmentright: function () {
      const that = this
      if (that.alllength > 4) {
        if (that.index + 1 > that.alllength - 4) {
          that.index = that.alllength - 4
        } else {
          that.index++
        }
      }
    },
    gundonh (type) {
      setTimeout(() => {
        if (type === 1) {
          window.scrollTo(0, 600)
        } else if (type === 2) {
          window.scrollTo(0, document.querySelector('.about-box2').offsetTop)
        } else if (type === 3) {
          window.scrollTo(0, document.querySelector('.about-box3').offsetTop)
        }
      }, 100)
    }
  },
  created () {
    this.type = this.$route.params.type
    const that = this
    Fetch.post('Api/column', {
      id: 1
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/about', {
    }).then((res) => {
      that.aboutitle = res.result.title
      that.aboutcontent = res.result.content
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/history', {
    }).then((res) => {
      that.alllength = res.result.length
      that.development = res.result
    }).catch(err => {
      console.log(err)
    })
  },
  watch: {
    '$route' (to, from) {
      this.gundonh(to.params.type)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .about-box1{
    width: 100%;
    padding-bottom: 70px;
    background-color: #fff;
  }
  .about-title{
    height: 50px;
    display: block;
    width: 100%;
    line-height: 50px;
    margin-top: 70px;
    font-size: 30px;
    color: #333;
    font-weight: bold;
    text-align: center;
  }
  .about-box1-cont{
    margin-top: 35px;
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .about-box2{
    width: 100%;
    height: 563px;
    background-color: #EFF1F2;
  }
  .qywhlist{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 40px;
  }
  .qywhlist li{
    width: 400px;
    height: 165px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .qywhlist li i{
    display: block;
    width: 100%;
    height: 40px;
  }
  .qywhlist li:nth-child(1) i{
    background:url(../assets/abouticon1.png) center 0 no-repeat
  }
  .qywhlist li:nth-child(2) i{
    background:url(../assets/abouticon2.png) center 0 no-repeat
  }
  .qywhlist li:nth-child(3) i{
    background:url(../assets/abouticon3.png) center 0 no-repeat
  }
  .qywhlist li:nth-child(4) i{
    background:url(../assets/abouticon4.png) center 0 no-repeat
  }
  .qywhlist li:nth-child(5) i{
    background:url(../assets/abouticon5.png) center 0 no-repeat
  }
  .qywhlist li:nth-child(6) i{
    background:url(../assets/abouticon6.png) center 0 no-repeat
  }
  .qywhlist li h1{
    display: block;
    width: 100%;
    height: 29px;
    line-height: 29px;
    margin-top: 19px;
    text-align: center;
    font-size: 20px;
    color: #333;
    font-weight: bold;
  }
  .qywhlist li span{
    display: block;
    width: 100%;
    line-height: 25px;
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
    color: #999;
  }
  .about-box3{
    height: 520px;
    position: relative;
  }
  .about-box3::after{
    content: "";
    width: 100%;
    height: 1px;
    background-color: #e1e1e1;
    position: absolute;
    top: 249px;
  }
  .brand{
    width: 100%;
    height: 200px;
    margin-top: 84px;
    position: relative;
  }
  .fzlclist{
    width: 1800px;
    height: 200px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
  }
  .fzlclist li{
    width: 300px;
    height: 200px;
    box-sizing: border-box;
    padding-left: 30px;
    cursor: pointer;
  }
  .fzlclist li h1{
    display: block;
    width: 100%;
    height: 22px;
    line-height: 22px;
    color: #333;
    font-size: 16px;
  }
  .fzlclist li i{
    width: 9px;
    display: block;
    height: 9px;
    background: #AAAAAA;
    border: 2px solid #E3E3E3;
    border-radius: 50%;
    margin-top: 18px;
    position: relative;
    z-index: 5;
  }
  .fzlclist li span{
    line-height: 25px;
    display: block;
    margin-top: 12px;
    font-size: 14px;
    color: #999;
  }
  .fzlclist li:hover h1{
    font-weight: bold;
  }
  .fzlclist li:hover i{
    background: #E40A20;
  }
  .fzlclist li:hover span{
    color: #333;
  }
  .btnbox{
    width: 100%;
    display: flex;
    height: 35px;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .btnbox div{
    width: 35px;
    height: 35px;
    cursor: pointer;
    background: url(../assets/fzlcbtn.png) 0 0 no-repeat;
    margin: 0 4px;
  }
  .btnbox .next{
    transform: rotate(180deg);
  }
  .btnbox div:hover{
    background: url(../assets/fzlcbtnh.png) 0 0 no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about.vue